/**
 * Global toast notification — singleton pattern.
 * Usage: import { showToast } from './Toast.jsx'
 *        showToast('Something went wrong')
 *        showToast('Saved!', 'success')
 */
import { useState, useEffect } from 'react'

let _dispatch = null

export function showToast(message, type = 'error') {
  _dispatch?.({ message: String(message), type, key: Date.now() })
}

export function ToastContainer() {
  const [toast, setToast] = useState(null)

  useEffect(() => {
    _dispatch = ({ message, type, key }) => {
      setToast({ message, type, key })
    }
    return () => { _dispatch = null }
  }, [])

  useEffect(() => {
    if (!toast) return
    const t = setTimeout(() => setToast(null), 4500)
    return () => clearTimeout(t)
  }, [toast?.key])

  if (!toast) return null

  const isError = toast.type === 'error'
  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`fixed bottom-24 left-1/2 z-[200] -translate-x-1/2 animate-slide-up rounded-2xl px-5 py-3 text-sm font-semibold text-white shadow-xl max-w-[90vw] text-center ${
        isError
          ? 'bg-red-500 shadow-red-500/30'
          : 'bg-emerald-500 shadow-emerald-500/30'
      }`}
    >
      {toast.message}
    </div>
  )
}
